import { render, staticRenderFns } from "./SuggestedComparisons.vue?vue&type=template&id=67d40f34&"
import script from "./SuggestedComparisons.vue?vue&type=script&lang=js&"
export * from "./SuggestedComparisons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports